var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeopleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.642 38.095"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 0a10.241 10.241 0 00-8.225 16.363 8.821 8.821 0 00-4.01 7.153v14.58h2.854V23.515a6.13 6.13 0 013.193-5.094 10.183 10.183 0 0012.443-.05 6.148 6.148 0 013.271 5.143v14.58h2.854V23.515a8.82 8.82 0 00-4.1-7.217 10.24 10.24 0 00-8.275-16.3zm0 17.666a7.405 7.405 0 117.405-7.405 7.412 7.412 0 01-7.405 7.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.854 21.206a2.97 2.97 0 011.325-2.324 6.826 6.826 0 10-1.991-2.081A5.738 5.738 0 000 21.201v8.465h2.854zM7.865 9.479a3.833 3.833 0 11-3.832 3.834A3.838 3.838 0 017.865 9.48zM49.396 16.756a6.61 6.61 0 00.984-3.442 6.693 6.693 0 10-2.953 5.544 2.972 2.972 0 011.361 2.35v8.465h2.857v-8.466a5.73 5.73 0 00-2.249-4.451zm-5.7.39a3.833 3.833 0 113.832-3.831 3.838 3.838 0 01-3.835 3.831z"
  }))));
}

export default SvgPeopleinline;